import { mapGetters } from "vuex";

/**
 * Get the item with the given id from the given list
 * @param {id} Number
 * @param {list} Array
 */
function findItemFromIdInList({ id, list }) {
  return list.find(user => {
    return user.id === id;
  });
}

export const providerDependentMixin = {
  computed: {
    ...mapGetters({
      getProvider: "getProvider",
      getAppointmentType: "getAppointmentType"
    }),
    /**
     * Get the current provider. If no providers false is returned
     */
    selectedProviderId() {
      // Step 1: Check if the provider list is empty. If empty return false
      if (this.getProvider.list.length <= 0) {
        return false;
      }

      // Step 2: Return the actual selected provider id
      return parseInt(this.getProvider.list[this.getProvider.selectedIndex].id);
    },
    /**
     * Returns the current selected index
     */
    selectedId() {
      return this.getAppointmentType.selectedId;
    },
    /**
     * Returns if appointment is of client type or of other type
     */
    type() {
      return this.getAppointmentType.selectedType;
    },
    /**
     * Returns the value that is selected
     */
    selectedValue() {
      // Step 1: Check if there is a provider id
      if (!this.selectedProviderId) {
        return {};
      }

      // Step 2: Check the type
      switch (this.getAppointmentType.selectedType) {
        case "person":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.clients[this.selectedProviderId]
          });

        case "event_appointment":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.events[this.selectedProviderId]
          });

        case "other_event":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.people[this.selectedProviderId]
          });

        case "group_appointment":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.groups[this.selectedProviderId]
          });

        case "app_user":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.appUsers[this.selectedProviderId]
          });

        case "subscriber":
          return findItemFromIdInList({
            id: this.getAppointmentType.selectedId,
            list: this.getAppointmentType.subscribers
          });

        default:
          return {};
      }
    },
    /**
     * The current selected name
     */
    selectedName() {
      // Step 1: Check if name is selected
      if (Object.prototype.hasOwnProperty.call(this.selectedValue, "name")) {
        return this.selectedValue.name;
      }

      // Step 2: When nothing is selected
      return "";
    }
  }
};
